import {createContext, useState} from 'react'

export const KnowledgeBaseContext = createContext(null)

const KnowledgeBaseContextProvider = ({children}) => {
  const [knowledgeBaseId, setKnowledgeBaseId] = useState(null)
  const [knowledgeBaseName, setKnowledgeBaseName] = useState(null)

  return (
    <KnowledgeBaseContext.Provider
      value={{knowledgeBaseId, setKnowledgeBaseId, knowledgeBaseName, setKnowledgeBaseName}}
    >
      {children}
    </KnowledgeBaseContext.Provider>
  )
}
export default KnowledgeBaseContextProvider
